<template>
  <div v-if="actionBar"
       class="product-detail-join-bar"
  >
    <div v-if="showContactUs"
         class="product-detail-join-bar-consult"
         @click="handleConsultDetail"
    >
      <ym-icon class="icon"
               name="vip-consult"
      />
      客服
    </div>

    <component :is="component"
               :render-price="renderPrice"
               :buttons="actionBar.buttons"
               :row-btn-round="rowBtnRound"
               class="product-detail-join-bar-component-bar"
               @click-primary="handleClickPrimary"
               @click-secondary="handleClickSecondary"
    />

    <confirm-pay-popup :show.sync="showPayPopup"
                       :target-id="benefitPopupTargetId"
                       :target-type="benefitPopupTargetType"
                       :title="benefitPopupTargetTitle"
                       :recommend="mixinRecommendBenefit"
                       :benefits="mixinBenefits"
                       :price="mixinShouldPay"
                       :rule="mixinPopupPayRule"
                       :modal-guide-info="modalGuideInfo"
    />

    <sku-popup :show.sync="mixinShowSkuPopup"
               :recommend-product="mixinSkuRecommendProduct"
               :config="mixinSkuConfig"
               :products="mixinSkuProducts"
               :initial-sku="mixinInitialSku"
    />
  </div>
</template>

<script>
  import DefaultBar from '@/components/ProductDetailBottom/components/DefaultJoinBar';
  import CoinExchangeBar from '@/components/ProductDetailBottom/components/CoinExchangeBar';
  import VipHighlightBar from '@/components/ProductDetailBottom/components/VipHighlightJoinBar';
  import VipHighlightVerticalBar
    from '@/components/ProductDetailBottom/components/VipHighlightVerticalJoinBar';
  import VipBar from '@/components/ProductDetailBottom/components/VipJoinBar';
  import VipChooseBar from '@/components/ProductDetailBottom/components/VipChooseJoinBar';
  import TrainingBar from '@/components/ProductDetailBottom/components/TrainingJoinBar';
  import ConfirmPayPopup from '@/components/ConfirmPayPopup';
  import SkuPopup from '@/components/SkuPopup';
  import joinProductMixin from '@/mixins/order/joinProduct';
  import validator from '@/utils/validator';
  import { underlineToHump, upperCaseFirst } from '@/utils';

  export default {
    name: 'ProductDetailJoinBar',
    mixins: [joinProductMixin],
    components: {
      DefaultBar,
      CoinExchangeBar,
      VipHighlightBar,
      VipHighlightVerticalBar,
      VipBar,
      VipChooseBar,
      TrainingBar,
      ConfirmPayPopup,
      SkuPopup,
    },
    props: {
      showContactUs: {
        type: Boolean,
        default: true,
      },
      product: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      actionBar: {
        type: Object,
        required: true,
      },
      modalGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      rowBtnRound: Boolean,
    },
    computed: {
      component() {
        const { actionBar } = this;
        const { style } = actionBar || {};
        if (style && style !== '') return `${upperCaseFirst(underlineToHump(style))}Bar`;
        return 'DefaultBar';
      },
      primaryJoin() {
        return this.actionBar.buttons.find((item, index) => index === 0);
      },
      secondaryJoin() {
        return this.actionBar.buttons.find((item, index) => index === 1);
      },
    },
    methods: {
      async handleAction(btn, product) {
        btn.disabled = true;
        const { action = 'joinProduct' } = btn;
        try {
          await this.mixinHandleClickJoinBtn(product, action);
          btn.disabled = false;
        } catch (e) {
          btn.disabled = false;
        }
      },
      async handleClickPrimary(product) {
        const { primaryJoin: primary } = this;
        const { disabled } = primary;
        if (disabled) return;

        this.handleAction(primary, product);
      },
      async handleClickSecondary(product) {
        const { secondaryJoin: secondary } = this;
        const { disabled } = secondary;
        if (disabled) return;

        this.handleAction(secondary, product);
      },
      handleConsultDetail() {
        const { id, type } = this.product;
        const route = {
          name: 'CustomerService',
          params: { id, type },
        };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-join-bar {
    display: flex;
    flex: 1;
    position: relative;

    &-component-bar {
      overflow: hidden;
      border-radius: 50px;
    }

    &-consult {
      flex-basis: @trail-program-size;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: @color-text-base;
      font-size: @font-size-extra-small;
      line-height: 1;

      .icon {
        margin-bottom: 8px;
        font-size: @font-size-extra-large;
      }
    }
  }
</style>
